// src/contexts/AppProviders.tsx
import React, { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';
import { BillingProvider } from './BillingContext';
import { EventsProvider } from './EventsContext';
import { UsersProvider } from './UsersContext';
import { ClientsProvider } from './ClientsContext';
import { AnalyticsProvider } from './AnalyticsContext';
import { NotificationsProvider } from './NotificationsContext';
import { TechnicalNotesProvider } from './TechnicalNotesContext';
import { InventoryProvider } from './InventoryContext';

export const AppProviders: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <AuthProvider>
            <BillingProvider>
                <EventsProvider>
                    <UsersProvider>
                        <ClientsProvider>
                            <AnalyticsProvider>
                                <NotificationsProvider>
                                    <TechnicalNotesProvider>
                                        <InventoryProvider>
                                            {children}
                                        </InventoryProvider>
                                    </TechnicalNotesProvider>
                                </NotificationsProvider>
                            </AnalyticsProvider>
                        </ClientsProvider>
                    </UsersProvider>
                </EventsProvider>
            </BillingProvider>
        </AuthProvider>
    );
};